import createIcon from '../../createIcon';

/**
 * @component @name Subject
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTdINFYxOUgxNFYxN1pNMjAgOUg0VjExSDIwVjlaTTQgMTVIMjBWMTNINFYxNVpNNCA1VjdIMjBWNUg0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Subject = createIcon('Subject', [
  [
    'path',
    { d: 'M14 17H4V19H14V17ZM20 9H4V11H20V9ZM4 15H20V13H4V15ZM4 5V7H20V5H4Z', key: '1nnyy7' },
  ],
]);

export default Subject;
